import Link from 'next/link';
import { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import AchievementsStore from '../../../stores/AchievementsStore';
import { AchievementList } from '../AchievementList';
import EntryBlock from '../EntryBlock';
import { achievementsSerializer } from '../utils';
import { AchievementGuestData } from '../types';
import styles from './styles.module.scss';

const AchievementsGuestPage = ({
  achievementsStore,
}: {
  achievementsStore?: AchievementsStore
}) => {
  const [activeAchievements, setActiveAchievements] = useState<AchievementGuestData[]>([]);
  const [archiveAchievements, setArchiveAchievements] = useState<AchievementGuestData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getAchievements = async () => {
    const result = await achievementsStore?.getAchievements();
    const achievements = achievementsSerializer(result).sort((a, b) => b.id - a.id);
    setActiveAchievements(achievements.filter(ach => !ach.isArchived));
    setArchiveAchievements(achievements.filter(ach => ach.isArchived))
  };

  useEffect(() => {
    getAchievements().then(() => setIsLoading(false));
  }, []);

  console.log(activeAchievements, archiveAchievements)

  return (
    <section className={styles.AchievementsGuestPage}>
      <EntryBlock />

      <AchievementList
        activeAchievements={activeAchievements}
        archiveAchievements={archiveAchievements}
        isLoading={isLoading}
      />

      {/* <DonorsFeedback /> */}

      <div className={styles.AchievementsGuestPage__registration}>
        <Link href="/login?next=/profile/achievements">Начать собирать ачивки</Link>
      </div>

      {/* <QuestionsBlock questions={QUESTIONS} withoutMargin /> */}
    </section>
  )
};

export default inject(
  "achievementsStore",
)(observer(AchievementsGuestPage));
